import * as React from 'react';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Stack from '@mui/material/Stack';
import clsx from 'clsx';

// import Polygon from '/public/home/Polygon';

import { IconButton } from '@mui/material';

import Link from 'next/link';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { makeStyles, withStyles } from '@mui/styles';
const styleObj = {
    '&:hover': {
        backgroundColor: 'red',
    },
    '&:active': {
        backgroundColor: 'blue',
    },
};
const useStyles = makeStyles({
    popper: {
        zIndex: 10,
    },
    menuBttn: {
        '&:hover': {
            backgroundColor: '#eaeaeaab',
            cursor: 'pointer',
        },
    },
    menuTex: {
        fontWeight: 700,
        fontSize: '14px',
        color: '#525252',
    },
    arrow: {
        fontSize: '15px !important',
        margin: '2px 0px 0px -4px',
        color: '#525252',
    },
    childName: {
        '&:hover': {
            color: '#2E3192 !important', // Simplified hover color
        },
        '&h4': {
            color: '#525252',
        },
    },
    h4: {
        '&:hover': {
            color: '#2E3192', // Hover color for the h4 element
        },
    },
});

const MenusList = ({ menu, classNames, popperClass }) => {
    const classes = useStyles();

    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') {
            setOpen(false);
        }
    }

    // return focus to the button when we transitioned from !open -> open
    // const prevOpen = React.useRef(open);
    // React.useEffect(() => {
    //     // if (prevOpen.current === true && open === false) {
    //     //     anchorRef.current.focus();
    //     // }
    //     anchorRef.current.focus();
    //     console.log('useEffect', anchorRef.current);
    //     prevOpen.current = open;
    // }, [open]);

    return (
        <Stack direction="row" spacing={2}>
            <div>
                <Button
                    // key={Math.random() * 1000}
                    ref={anchorRef}
                    id="composition-button"
                    aria-controls={open ? 'composition-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleToggle}
                    // onMouseEnter={handleToggle}
                    onMouseLeave={handleClose}
                    style={{ color: '#eaeaeaab' }}
                    className={classes.menuBttn}
                    // disableRipple
                    // sx={styleObj}
                    variant="text"
                    endIcon={menu.children ? <ExpandMoreIcon className={classes.arrow} /> : null}
                >
                    {menu.link !== null
                        ? [
                              menu.link === 'home' ? (
                                  <Link legacyBehavior href="/">
                                      <a>
                                          <Typography className={classes.menuTex}>
                                              {menu.name}
                                          </Typography>
                                      </a>
                                  </Link>
                              ) : menu.name?.toLowerCase().includes('tacrim') ? (
                                  <a href={menu.link} rel="noreferrer">
                                      <Typography className={classes.menuTex}>
                                          {menu.name}
                                      </Typography>
                                  </a>
                              ) : (
                                  <a target="_blank" href={menu.link} rel="noreferrer">
                                      <Typography className={classes.menuTex}>
                                          {menu.name}
                                      </Typography>
                                  </a>
                              ),
                          ]
                        : [
                              !menu.children ? (
                                  <Link
                                      legacyBehavior
                                      href={`/post/${menu.id}${
                                          menu.name?.toLowerCase().includes('tacrim')
                                              ? '?tacrim'
                                              : ''
                                      }`}
                                  >
                                      <a>
                                          <Typography className={classes.menuTex}>
                                              {menu.name}
                                          </Typography>
                                      </a>
                                  </Link>
                              ) : (
                                  <Typography className={classes.menuTex}>{menu.name}</Typography>
                              ),
                          ]}
                </Button>
                <Popper
                    open={open}
                    className={clsx(classes.popper, popperClass)}
                    anchorEl={anchorRef.current}
                    role={undefined}
                    placement="bottom-start"
                    transition
                    disablePortal
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin:
                                    placement === 'bottom-start' ? 'left top' : 'left bottom',
                            }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <MenuList
                                        autoFocusItem={open}
                                        id="composition-menu"
                                        aria-labelledby="composition-button"
                                        onKeyDown={handleListKeyDown}
                                        onMouseLeave={handleClose}
                                    >
                                        {menu.children &&
                                            menu.children.map((child, ind) => {
                                                return (
                                                    <div
                                                        key={Math.floor(Math.random() * 100 + ind)}
                                                    >
                                                        {child.link === null ? (
                                                            <Link
                                                                legacyBehavior
                                                                href={`/post/${child.id}`}
                                                                key={Math.floor(
                                                                    Math.random() * 100 + child.id
                                                                )}
                                                            >
                                                                <a>
                                                                    <MenuItem
                                                                        className={
                                                                            classes.childName
                                                                        }
                                                                        key={Math.floor(
                                                                            Math.random() * 100 +
                                                                                child.id
                                                                        )}
                                                                        onClick={handleClose}
                                                                    >
                                                                        <Typography variant="h4">
                                                                            {child.name}
                                                                        </Typography>
                                                                    </MenuItem>
                                                                </a>
                                                            </Link>
                                                        ) : (
                                                            <MenuItem
                                                                key={Math.floor(
                                                                    Math.random() * 100 + ind
                                                                )}
                                                                className={classes.childName}
                                                                href={`/` + child.link}
                                                                // onClick={() =>
                                                                //     window.open(
                                                                //         child.link,
                                                                //         '_blank'
                                                                //     )
                                                                // }
                                                                component="a"
                                                                // onClick={handleClose}
                                                            >
                                                                <Typography variant="h4">
                                                                    {child.name}
                                                                </Typography>
                                                            </MenuItem>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </div>
        </Stack>
    );
};

export default MenusList;
